// Hook for sitemap functionality
import { useState, useEffect } from 'react';
import { getCachedSitemap } from '../utils/sitemapUtils';

export const useSitemap = () => {
    const [sitemap, setSitemap] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [lastUpdated, setLastUpdated] = useState(null);

    const refreshSitemap = async () => {
        try {
            setLoading(true);
            setError(null);
            
            // Get fresh sitemap (bypasses cache)
            const jsonData = await getCachedSitemap('json');
            setSitemap(jsonData);
            setLastUpdated(new Date());
        } catch (err) {
            console.error('Error refreshing sitemap:', err);
            setError(err.message || 'Failed to refresh sitemap');
        } finally {
            setLoading(false);
        }
    };

    const downloadXMLSitemap = async () => {
        try {
            const xmlData = await getCachedSitemap('xml');
            const blob = new Blob([xmlData], { type: 'application/xml' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `sitemap-${new Date().toISOString().split('T')[0]}.xml`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        } catch (err) {
            console.error('Error downloading XML sitemap:', err);
            throw new Error('Failed to download sitemap');
        }
    };

    const copyXMLSitemap = async () => {
        try {
            const xmlData = await getCachedSitemap('xml');
            await navigator.clipboard.writeText(xmlData);
            return true;
        } catch (err) {
            console.error('Error copying XML sitemap:', err);
            throw new Error('Failed to copy sitemap to clipboard');
        }
    };

    useEffect(() => {
        refreshSitemap();
    }, []);

    return {
        sitemap,
        loading,
        error,
        lastUpdated,
        refreshSitemap,
        downloadXMLSitemap,
        copyXMLSitemap
    };
};

export default useSitemap;